'use strict';
angular.module('newspaperArchiveDraftModule', []).controller('newspaperArchiveDraftCtrl', ['$scope', '$timeout', '$q', '$stateParams', '$cacheFactory', '$modal', 'trsHttpService', 'initSingleSelecet', 'editNewspaperService', 'trsspliceString', 'modalDialog', 'editingCenterService', '$interval', 'initVersionService', 'trsPrintService', 'storageListenerService', 'globleParamsSet', 'editcenterRightsService', 'pagePreview', '$state', '$window', '$filter', 'localStorageService', 'editIsLock', 'publicToolService',
    function($scope, $timeout, $q, $stateParams, $cacheFactory, $modal, trsHttpService, initSingleSelecet, editNewspaperService, trsspliceString, modalDialog, editingCenterService, $interval, initVersionService, trsPrintService, storageListenerService, globleParamsSet, editcenterRightsService, pagePreview, $state, $window, $filter, localStorageService, editIsLock, publicToolService) {
        initStatus();
        initData();

        /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 0
            };
            $scope.params = {
                serviceid: 'mlf_paper',
                methodname: 'queryGuiDangDocs',
                PaperId: $stateParams.paperid,
                // OprTime: '1m'
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
            $scope.status = {
                isShowList: true,
                btnRights: '',
                selectdTimeDefault: '',
                selectdTime: '',
                docType: '',
                hasphoto: false, // 是否是图集稿
                hasphotoflag: true, // 判断是否人为点击图集切换模式
                docTypeJsons: '',
                isOpenedPanelArray: { // 默认打开第一个面板
                    0: true
                },
                yqgpreview: 4,
                jrgedit: 1,
                newspaperEdit: editNewspaperService.initNewspaperEdit(),
                cachedName: 'newspaperArchiveDocuments', // 缓存key
                cacheOpenedPanel: {},
                cacheOpenedPanelKey: 'gdg',
                isESSearch: false

            };
            $scope.data = {
                paperMsg: '',
                selectedArray: [],
                panels: [],
                BanMian: {
                    selectedBanMian: {},
                    BanMianArray: [],
                },
                selectedArrayObj: [],
                selectAllWords: 0, // 列表下选中总字数
                ownerArr: [],
                AllBMRights: {},
                orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                selectedOrder: editingCenterService.getNewspaperOrder()[0],
            };
        }

        /**
             * [initData description]
             *
             * @return  {[type]}  [return description]
             */
        function initData() {
            editingCenterService.getSiteInfo($stateParams.paperid).then(function(data) {
                $scope.data.paperMsg = data;
            });
            initDropDown();
            // requestData();
            listenStorage();
            editcenterRightsService.initNewspaperListBtn('paper.guidang', $stateParams.paperid).then(function(data) {
                $scope.status.btnRights = data;
            });
            listenerCacheDate();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            publicToolService.getModeconfiguration('newspaperDefaultOrderByTime').then((config) => {
                $scope.data.selectedOrder = (config === 'true' ? editingCenterService.getNewspaperOrder()[1] : editingCenterService.getNewspaperOrder()[0]);
                requestData();
            },
            () => {
                requestData();
            });
            
        };
        
        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenNewspaper(function() {
                requestData();
                storageListenerService.removeListener('newspaper');
            }, $scope);
            $scope.$on('$destroy', function() {
                localStorageService.remove('newspaperPreviewSelectArray');
                localStorageService.remove('newspaperPreviewCache');
            });
        }

        /**
             * [initDropDown description]
             *
             * @return  {[type]}  [return description]
             */
        function initDropDown() {
            $scope.status.selectdTime = initSingleSelecet.chooseTimeType();
            $scope.status.selectdTimeDefault = angular.copy($scope.status.selectdTime[3]);
            $scope.status.docTypeJsons = initSingleSelecet.newspaperDraftType();
            $scope.data.selectedDocType = angular.copy($scope.status.docTypeJsons[0]);

            $scope.data.conditionsSearch = editNewspaperService.newspaperEntire();
            $scope.data.selectedConditions = angular.copy(editNewspaperService.newspaperEntire()[0]);

            // 版面
            editNewspaperService.screenFilter($state.params.paperid).then(function(data) {
                $scope.data.BanMian.BanMianArray = data;
                $scope.data.BanMian.selectedBanMian = data[0];
            });
            // editingCenterService.dealStorage($scope);
        }

        /**
             * [requestData description]
             *
             * @return  {[type]}  [return description]
             */
        function requestData() {
            var deferred = $q.defer();
            var params = $scope.status.isESSearch ? getESSearchParams() : angular.copy($scope.params);
            if ($scope.status.isShowList) {
                params.PageSize = $scope.page.PAGESIZE;
                params.PAGEINDEX = $scope.page.CURRPAGE;
                if (!$scope.status.isESSearch) {
                    params.NoPage = !$scope.status.isESSearch && $scope.status.isShowList;
                    params.ChannelId = $scope.data.BanMian.selectedBanMian.CHANNELID;
                }
            } else {
                params.ChannelId = '';
            }
            params.OrderType = $scope.data.selectedOrder.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'GET').then(function(data) {
                var fileterObj = {};
                if ($scope.status.isShowList) {
                    $scope.data.items = $scope.data.panels = data.DATA;
                    if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                        $scope.status.hasphoto = true;
                    } else {
                        $scope.status.hasphoto = false;
                    }
                    $scope.page = data.PAGER;
                    fileterObj = editNewspaperService.extractParametersList(data.DATA, {
                        namekey: 'OWNERTRUENAME',
                        valuekey: 'OWNERNAME',
                        title: '所有者'
                    });
                    $scope.data.ownerArr = $scope.data.ownerArr.concat(fileterObj.nameArr);
                    $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                    editNewspaperService.liebiaoListItemCache(data.DATA);
                } else {
                    $scope.status.hasphoto = false;
                    fileterObj = editNewspaperService.extractParameters(data, {
                        namekey: 'OWNERTRUENAME',
                        valuekey: 'OWNERNAME',
                        title: '所有者'
                    });
                    $scope.data.ownerArr = fileterObj.nameArr;
                    $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                    cacheDate(data);
                    openDefaultPanels();
                }
                if (!$scope.data.selectOwner) {
                    $scope.data.selectOwner = $scope.data.ownerArr[0];
                }
                $scope.data.selectedArray = [];
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [listeningcacheDate description] 监听缓存
         * @return {[type]} [description]
         */
        function listenerCacheDate() {
            $scope.$on('$destroy', function() {
                $interval.cancel($scope.promise);
                pagePreview.cleanCache();
            });
        }

        /**
             * [cacheDate description]缓存数据以提高渲染速度
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
        function cacheDate(data) {
            if ($cacheFactory.get($scope.status.cachedName)) {$cacheFactory.get($scope.status.cachedName).destroy();}
            var copyedData = angular.copy(data);
            $scope.data.selectedArrayObj = [];
            var cache = $cacheFactory($scope.status.cachedName);
            var documents = [];
            for (var i in copyedData) {
                cache.put(copyedData[i].BANMIANID, copyedData[i].DOCUMENTS);
                $scope.data.selectedArrayObj = $scope.data.selectedArrayObj.concat(copyedData[i].DOCUMENTS);
                documents.push(copyedData[i].DOCUMENTS);
                if (i > 0) {copyedData[i].DOCUMENTS = [];}
            }
            $scope.data.panels = copyedData;
            listItemCache(documents);
        }

        /**
             * [setOpendPanel description]将打开的panel缓存起来
             * @param {[type]} index [description]
             * @return  {[type]}        [return description]
             */
        function setOpendPanel(index) {
            for (var i in $scope.status.isOpenedPanelArray) {
                $scope.status.cacheOpenedPanel[$scope.data.panels[i].BANMIANID] = $scope.status.isOpenedPanelArray[i];
            }
            editNewspaperService.cacheOpenedPanel($scope.status.cacheOpenedPanelKey, $scope.status.cacheOpenedPanel);
        }

        /**
         * [openDefaultPanels description]打开默认的panel
         * @return {[type]} [description]
         */
        function openDefaultPanels() {
            var tempOpenedPanels = editNewspaperService.getCacheOpenedPanel($scope.status.cacheOpenedPanelKey);
            if (angular.isUndefined(tempOpenedPanels)) {
                $scope.status.isOpenedPanelArray[0] = true;
                return;
            }
            $scope.status.isOpenedPanelArray[0] = false;
            for (var i in $scope.data.panels) {
                if (tempOpenedPanels[$scope.data.panels[i].BANMIANID] === true) {
                    $scope.status.isOpenedPanelArray[i] = true;
                    getCachedById(i);
                }
            }
        }

        /**
         * [getCachedById description]点击版面加载缓存的数据，以提高页面加载速度
         * @param  {[type]} index [description]  panel下标
         * @return {[type]}       [description]
         */
        $scope.getCachedById = function(index) {
            setOpendPanel(index);
            if ($scope.data.panels[index].DOCUMENTS.length > 0) {return;} else {
                $scope.loadingPromise = getCachedById(index);
            }
        };

        /**
         * [getCachedById description] 获取对应panel下缓存的DOCUMENTS 为了展示loadingPromise
         * @param  {[type]} index [description] panel下标
         * @return {[type]}       [description] promise
         */
        function getCachedById(index) {
            var deferred = $q.defer();
            var panel = $scope.data.panels[index];
            if (panel.DOCUMENTS.length === 0) {
                var cache = $cacheFactory.get($scope.status.cachedName);
                panel.DOCUMENTS = cache.get(panel.BANMIANID);
                deferred.resolve();
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }

        /**
             * [listItemCache description]缓存存储
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
        function listItemCache(data) {
            var cachePreviewMetadataid = [];
            angular.forEach(data, function(data, index, array) {
                angular.forEach(data, function(_data, _index, _array) {
                    cachePreviewMetadataid.push(_data.METADATAID);
                });
            });
            localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
        }

        /**
             * [selectedArrayCahe description]缓存当前选中项
             *
             * @param   {[type]}  array  [array description]选中对象
             *
             * @return  {[type]}         [return description]
             */
        function selectedArrayCahe(array) {
            var selectedArray = angular.copy(array);
            var selectedArrayMetadaid = [];
            angular.forEach(selectedArray, function(data, index) {
                selectedArrayMetadaid.push(data.METADATAID);
            });
            localStorageService.set('newspaperPreviewSelectArray', selectedArrayMetadaid); // paged
        }

        // 监听预览页 按钮点击
        $window.addEventListener('storage', function(e) {
            $scope.data.selectedCurrents = angular.copy(localStorageService.get('newspaperPreviewSelectArray')); // page
            $scope.$apply(function() {
                selectCurArray($scope.data.selectedCurrents);
            });
        });

        /**
             * [selectCurArray description]遍历出选择对象
             *
             * @param   {[type]}  curSelectedArray  [curSelectedArray description]当前选中对象
             *
             * @return  {[type]}                    [return description]
             */
        function selectCurArray(curSelectedArray) { // o
            if (curSelectedArray === null) {return;}
            // var arrays=[];
            $scope.data.selectedArray = [];
            for (var i = 0; i < curSelectedArray.length; i++) {
                for (var j = 0; j < $scope.data.selectedArrayObj.length; j++) {
                    if (curSelectedArray[i] === $scope.data.selectedArrayObj[j].METADATAID) {
                        $scope.data.selectedArray.push($scope.data.selectedArrayObj[j]);
                    }
                }
            }
        }

        /**
             * [selectItem description]单选某稿件
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
        $scope.selectItem = function(item) {
            var num = $scope.data.selectedArray.indexOf(item);
            if (num > -1) {
                $scope.data.selectedArray.splice(num, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
            selectedArrayCahe($scope.data.selectedArray); // si
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, items.CHANNELID, 'paper.gdg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };

        /**
             * [selectAllItem description]全选或者取消全选的操作
             *
             * @return  {[type]}  [return description]
             */
        $scope.selectAllItem = function() {
            if ($scope.data.selectedArray.length === $scope.data.shangbanDocList.length && $scope.data.shangbanDocList.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.shangbanDocList.length; i++) {
                    $scope.data.selectedArray.push($scope.data.shangbanDocList[i]);
                }
            }
            selectedArrayCahe($scope.data.selectedArray);
        };
        // 分类全选
        $scope.selectAllType = function(items, index) {
            $scope.status.judgement = determineItemsInSelectedArray(items);
            if ($scope.status.judgement) {
                deleteItemsInSelectedArray(items);
            } else {
                addDraftInSelectedArray(items, index);
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, $scope.data.panels[index].DOCUMENTS[0].CHANNELID, 'paper.gdg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };
        $scope.determineItemsInSelectedArray = function(item) {
            return determineItemsInSelectedArray(item);
        };

        /**
         * [determineItemsInSelectedArray description]判断某个版面的元素是否全在选中的数组中
         * @param  {[array]} item [description]版面的所有稿件
         * @return {[bollean]}      [description]是否都在
         */
        function determineItemsInSelectedArray(item) {
            var isAllIn = true;
            if (item.length === 0) {return false;}
            for (var i = 0; i < item.length; i++) {
                if ($scope.data.selectedArray.indexOf(item[i]) < 0) {
                    isAllIn = false;
                }
            }
            return isAllIn;
        }

        /**
         * [deleteItemsInSelectedArray description]删除指点版面下所有在selectArray中的稿件
         * @param  {[array]} item [description]
         * @return {[type]}      [description]
         */
        function deleteItemsInSelectedArray(item) {
            for (var i = 0; i < item.length; i++) {
                if ($scope.data.selectedArray.indexOf(item[i]) > -1) {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item[i]), 1);
                }
            }
        }

        /**
             * [addDraftInSelectedArray description]向selectArray中添加元素
             *
             * @param   {[type]}  items  [items description]版面的所有稿件
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
        function addDraftInSelectedArray(items, index) {
            if (items.length === 0) {
                $scope.status.isOpenedPanelArray[index] = true;
                $scope.getCachedById(index);
                items = $scope.data.panels[index].DOCUMENTS;
            }
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                    $scope.data.selectedArray.push(items[i]);
                }
            }
        }
        // 流程版本与操作日志
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };

        /*
         * [isChecked description] 点击单选
         * @item {[type]} [description]  当前选择值
         */
        $scope.isChecked = function(item) { // page
            return getIndex(item) >= 0;
        };

        /**
             * [getIndex description]单选方法
             *
             * @param   {[type]}  item  [item description]当前选择值
             *
             * @return  {[type]}        [return description]
             */
        function getIndex(item) {
            var selectedArray = $scope.data.selectedArray;
            for (var index = 0; index < selectedArray.length; index++) {
                if (selectedArray[index].METADATAID == item.METADATAID) {
                    return index;
                }
            }
            return -1;
        }

        /**
             * [selectItem description]单独选中某稿件或者取消选中
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
        $scope.selectItem = function(item) {

            var num = -1;
            for (var index = 0; index < $scope.data.selectedArray.length; index++) {
                if ($scope.data.selectedArray[index].METADATAID == item.METADATAID) {
                    num = index;
                    break;
                }
            }
            if (num > -1) {
                $scope.data.selectedArray.splice(num, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
            selectedArrayCahe($scope.data.selectedArray); // arc
        };

        /** [selectAllItem description]全选稿件 */
        $scope.selectAllItem = function() {
            if ($scope.data.selectedArray.length === $scope.data.guidangDocsList.length && $scope.data.guidangDocsList.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.guidangDocsList.length; i++) {
                    $scope.data.selectedArray.push($scope.data.guidangDocsList[i]);
                }
            }
            selectedArrayCahe($scope.data.selectedArray);
        };

        /**
             * [newspaperPreview description]报纸预览
             *
             * @param   {[type]}  item  [item description]当前对象
             *
             * @return  {[type]}        [return description]
             */
        $scope.newspaperPreview = function(item) {
            storageListenerService.previewPageTurningStorage($scope.data.guidangDocsList, 'METADATAID,SITEID,DOCTYPEID', 'newspaperPreview');
            var editPath = 'newspaperNewsPreview';
            var editParams = {
                paperid: item.SITEID,
                bzmetadata: item.METADATAID,
                newspapertype: $scope.status.yqgpreview
            };
            var editUrl = $state.href(editPath, editParams);
            // 缓存当前选中项
            // pagePreview.selectedArrayCahe($scope.data.selectedArray);
            // 缓存所有列表METADATAID
            // listItemCache($scope.data.selectedArrayObj);
            $window.open(editUrl);
        };

        /**
             * [queryByDropdown description]获取下拉框数据后的回调函数
             *
             * @param   {[type]}  param  [param description]
             * @param   {[type]}  value  [value description]
             *
             * @return  {[type]}         [return description]
             */
        $scope.queryByDropdown = function(param, value) {
            if (param === 'ChannelId') {
                $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, value, $stateParams.paperid, 'paper.gdg').then(function(data) {
                    $scope.status.btnRights = data;
                });
            }
            if (param === 'ChannelId' && !$scope.status.isShowList) {
                return;
            }
            if (param === 'DocType' && value === '2') {
                $scope.status.hasphotoflag = true;
            }
            $scope.params[param] = value;
            // if (param == 'OprTime') {
            //     if (value.length < 10) {
            //         $scope.params.OprTimeStart = null;
            //         $scope.params.OprTimeEnd = null;
            //     } else {
            //         $scope.params.OprTimeStart = $scope.data.fromdate;
            //         $scope.params.OprTimeEnd = $scope.data.untildate;
            //         $scope.params[param] = null;
            //     }
            // }
            $scope.page.CURRPAGE = 1;
            requestData();
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            $scope.selectItemList(item);
        };

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function() {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };
        
        /**
         * [goToDetail description]图集模式跳转细览页
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item){
            $scope.newspaperPreview(item);
        };
        
        
        /**
         * [reduction description]还原操作
         * @return {[type]} [description]
         */
        $scope.reduction = function() {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function(data){
                modalDialog.inputModel('还原', '还原意见（可选）', function(content) {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'doRestore',
                        SrcDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                        // SrcBanMianIds: trsspliceString.spliceString($scope.data.selectedArray, "CHNLID", ","),
                        Option: content
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('', '还原成功', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            });
        };

        /**
         * [deleteNews description]
         *
         * @return  {[type]}  [return description]删除稿件
         */
        $scope.deleteNews = function() {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function(data){
                modalDialog.confirmModal('删除', '确定删除所选稿件吗', function() {
                    var params = {
                        serviceId: 'mlf_paper',
                        methodName: 'trashMetaDatas',
                        DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                        modalDialog.multiReportsAlert(data, function() {
                            requestData();
                        });
                    });
                });
            });
        };

        /**
         * [fullTextSearch description]es检索
         * @param  {[obj]} ev [description]事件
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isESSearch = true;
                $scope.status.isOpenedPanelArray = {};
                requestData();
            }
        };

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: $scope.status.isShowList ? 'queryForPaperGuiDangDocNoPage' : 'queryForPaperGuiDangDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [{
                        searchField: $scope.data.selectedConditions.value,
                        keywords: $scope.status.keywords ? $scope.status.keywords : ''
                    }, {
                        searchField: 'docType',
                        keywords: $scope.data.selectedDocType.value
                    }, {
                        searchField: 'paperid',
                        keywords: $stateParams.paperid
                    }, {
                        searchField: '_sort',
                        keywords: ''
                    }, {
                        searchField: 'OwnerName',
                        keywords: $scope.data.selectOwner.value
                    }]
                }
            };
            if ($scope.status.isShowList) {
                esParams.searchParams.searchFields.push({
                    searchField: 'CHANNELID',
                    keywords: $scope.data.BanMian.selectedBanMian.CHANNELID
                });
            }
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        /**
             * [isLockEdit description]编辑前请求解锁
             *
             * @param   {[type]}  item  [item description]稿件对象
             *
             * @return  {[type]}        [return description]
             */
        $scope.isLockEdit = function(item) {
            editIsLock.isLock(item, 3).then(function(data) {
                var editPath = $scope.status.newspaperEdit[item.DOCTYPEID];
                var editParams = {
                    papermetadataid: item.METADATAID,
                    paperid: item.SITEID,
                    newspapertype: $scope.status.jrgedit
                };
                var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function() {
                        $window.open(editUrl);
                    });
                }
            });
        };

        /** *************************list模式方法**************************/

        /**
         * [pageChanged description] 换页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [selectAllList description] 全选
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectAllList = function() {
            $scope.data.selectAllWords = 0;
            if ($scope.data.selectedArray.length === $scope.data.panels.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.panels);
                $scope.data.panels.forEach(function(item) {
                    $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
                });
            }
        };

        /**
         * [selectItemList description] 单选
         *
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.selectItemList = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index === -1) {
                $scope.data.selectedArray.push(item);
                $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
            } else {
                $scope.data.selectedArray.splice(index, 1);
                $scope.data.selectAllWords -= parseInt(item.DOCWORDSCOUNT);
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.gdg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };

        /**
         * [changeMode description] 切换时折叠模式还是列表模式
         *
         * @return  {[type]}  [return description]
         */
        $scope.changeMode = function() {
            // $scope.page.PAGESIZE = 50;
            $scope.page.CURRPAGE = 1;
            $scope.data.panels = [];
            $scope.status.isShowList = !$scope.status.isShowList;
            requestData();
        };

    }

]);
